export const RAM=[
    {"name":"Select your choice","Score":0},
    {"name":"128 MB","Score":1},
    {"name":"256 MB","Score":2},
    {"name":"512 MB","Score":3},
    {"name":"1 GB","Score":4},
    {"name":"2 GB","Score":5},
    {"name":"3 GB","Score":6},
    {"name":"4 GB","Score":7},
    {"name":"5 GB","Score":8},
    {"name":"6 GB","Score":9},
    {"name":"8 GB","Score":10},
    {"name":"10 GB","Score":11},
    {"name":"12 GB","Score":12},
    {"name":"14 GB","Score":13},
    {"name":"16 GB","Score":14},
    {"name":"32 GB","Score":15},
    {"name":"64 GB","Score":16},
    {"name":"96 GB","Score":17},
    {"name":"128 GB","Score":18}
    
]